module.exports = __webpack_public_path__ + "static/media/no-results-search-icon.80f32141.svg";